import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import heroBg from '@/assets/images/home/hero-bg.jpg'
import work1 from '@/assets/images/home/work-1.jpg'
import work2 from '@/assets/images/home/work-2.jpg'
import yolkIntro from '@/assets/images/about/yolk-intro.jpg'
import work5 from '@/assets/images/home/work-5.jpg'
import honeyHouseImg from '@/assets/images/home/honey-house.png'
import loaImg from '@/assets/images/home/loa.png'

const HOME_CSS = `
  #home-root * { margin: 0; padding: 0; box-sizing: border-box }
  #home-root { font-family: 'DM Sans', sans-serif; color: #fff; -webkit-font-smoothing: antialiased }
  #hero-img { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; object-fit: cover; z-index: 10; opacity: 1; transition: opacity .3s }
  .home-flash { position: fixed; border-radius: 50%; background: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,.8) 20%, rgba(255,255,255,0) 70%); z-index: 11; pointer-events: none; opacity: 0; animation: home-twinkle .6s ease-in-out forwards }
  @keyframes home-twinkle { 0% { opacity: 0; transform: scale(.3) } 30% { opacity: 1; transform: scale(1) } 60% { opacity: .8; transform: scale(1.2) } 100% { opacity: 0; transform: scale(.5) } }
  #hero-section { position: relative; width: 100%; height: 100vh; z-index: 5 }
  #phone-frame { position: fixed; z-index: 6; opacity: 0; transition: opacity 1s ease; pointer-events: none }
  #phone-frame.interactive { pointer-events: auto }
  #phone-screen { position: absolute; border-radius: 20px; overflow: hidden; background: #111 }
  .phone-slides { display: flex; width: 400%; height: 100%; transition: transform .5s cubic-bezier(.25,.8,.25,1) }
  .phone-slide { width: 25%; height: 100%; flex-shrink: 0; display: flex; align-items: center; justify-content: center; padding: 20px; text-align: center }
  .phone-slide img { width: 100%; height: 100%; object-fit: cover; opacity: 0; transition: opacity 1.5s ease; position: absolute; top: 0; left: 0 }
  .phone-slide img.visible { opacity: 1 }
  .phone-slide-text { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 700; font-size: clamp(.85rem, 2.2vw, 1.2rem); line-height: 1.4; letter-spacing: .02em; text-transform: uppercase; opacity: 0; transform: translateY(15px); transition: opacity .8s ease, transform .8s ease }
  .phone-slide-text.visible { opacity: 1; transform: translateY(0) }
  #swipe-dots { position: fixed; z-index: 20; display: flex; gap: 8px; opacity: 0; transition: opacity .5s; pointer-events: none }
  #swipe-dots.visible { opacity: 1; pointer-events: auto }
  .dot { width: 6px; height: 6px; border-radius: 50%; background: rgba(255,255,255,.25); transition: background .3s, transform .3s; cursor: pointer }
  .dot.active { background: #fff; transform: scale(1.4) }
  .hero-text { position: fixed; z-index: 20; text-align: center; width: 90%; left: 5%; opacity: 0; transform: translateY(30px); transition: opacity 1s ease, transform 1s ease; pointer-events: none }
  .hero-text.visible { opacity: 1; transform: translateY(0) }
  .hero-text h1 { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 800; font-size: clamp(1.5rem, 5vw, 3rem); line-height: 1.15; letter-spacing: -.02em; text-transform: uppercase }
  .hero-text p { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 600; font-size: clamp(.8rem, 2.5vw, 1.1rem); letter-spacing: .15em; text-transform: uppercase; opacity: .45 }
  #tap-prompt { position: fixed; bottom: 80px; left: 50%; transform: translateX(-50%); z-index: 25; font-size: .7rem; letter-spacing: .2em; text-transform: uppercase; opacity: 0; animation: home-pulse 2s ease-in-out infinite; transition: opacity .5s; pointer-events: none }
  #tap-prompt.visible { opacity: .5 }
  #tap-prompt.hidden { opacity: 0 !important; animation: none }
  @keyframes home-pulse { 0%, 100% { opacity: .3 } 50% { opacity: .7 } }
  #scroll-cue { position: fixed; bottom: 60px; left: 50%; transform: translateX(-50%); z-index: 25; opacity: 0; transition: opacity 1s; pointer-events: none; text-align: center }
  #scroll-cue.visible { opacity: 1 }
  #scroll-cue span { display: block; font-size: .65rem; letter-spacing: .2em; text-transform: uppercase; opacity: .4; margin-bottom: 8px }
  #scroll-cue .arrow { width: 20px; height: 20px; border-right: 1.5px solid rgba(255,255,255,.4); border-bottom: 1.5px solid rgba(255,255,255,.4); transform: rotate(45deg); margin: 0 auto; animation: home-bounce 2s infinite }
  @keyframes home-bounce { 0%, 100% { transform: rotate(45deg) translateY(0) } 50% { transform: rotate(45deg) translateY(6px) } }
  #home-footer { position: fixed; bottom: 0; left: 0; width: 100%; z-index: 30; padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; opacity: 0; transform: translateY(20px); transition: opacity 1s ease .3s, transform 1s ease .3s; background: linear-gradient(transparent, rgba(0,0,0,.8)) }
  #home-footer.visible { opacity: 1; transform: translateY(0) }
  #home-footer .logo { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 700; font-size: .75rem; letter-spacing: .3em; text-transform: uppercase; opacity: .6 }
  #home-footer nav { display: flex; gap: 20px }
  #home-footer nav a { color: #fff; text-decoration: none; font-size: .7rem; letter-spacing: .15em; text-transform: uppercase; opacity: .5; transition: opacity .3s; cursor: pointer }
  #home-footer nav a:hover { opacity: 1 }
  #particle-canvas { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 8; pointer-events: none }
  #portfolio { position: relative; z-index: 40; background: #000; padding: 80px 20px 100px; display: none }
  #portfolio.visible { display: block }
  #portfolio-header { text-align: center; margin-bottom: 60px }
  #portfolio-header h2 { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 800; font-size: clamp(1.4rem, 4vw, 2.4rem); text-transform: uppercase; letter-spacing: -.01em; margin-bottom: 12px }
  #portfolio-header p { font-size: .8rem; letter-spacing: .15em; text-transform: uppercase; opacity: .35 }
  .portfolio-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; max-width: 900px; margin: 0 auto }
  .portfolio-tile { position: relative; border-radius: 12px; overflow: hidden; aspect-ratio: 3/4; cursor: pointer; transform: translateY(40px); opacity: 0; transition: transform .8s cubic-bezier(.16,1,.3,1), opacity .8s ease }
  .portfolio-tile.revealed { transform: translateY(0); opacity: 1 }
  .portfolio-tile:nth-child(2n) { transform: translateY(60px) }
  .portfolio-tile.revealed:nth-child(2n) { transform: translateY(0) }
  .tile-img { width: 100%; height: 100%; object-fit: cover; transition: transform .6s ease }
  .portfolio-tile:hover .tile-img { transform: scale(1.05) }
  .tile-overlay { position: absolute; inset: 0; display: flex; flex-direction: column; justify-content: flex-end; padding: 20px }
  .tile-overlay h3 { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 700; font-size: clamp(.85rem, 2vw, 1.1rem); text-transform: uppercase; letter-spacing: .05em; line-height: 1.3; text-shadow: 0 2px 20px rgba(0,0,0,.6) }
  .tile-overlay span { font-size: .65rem; letter-spacing: .15em; text-transform: uppercase; opacity: .6; margin-top: 4px }
  .filter-magenta .tile-overlay { background: linear-gradient(transparent 40%, rgba(200,30,120,.7)) }
  .filter-cyan .tile-overlay { background: linear-gradient(transparent 40%, rgba(0,180,200,.65)) }
  .filter-orange .tile-overlay { background: linear-gradient(transparent 40%, rgba(255,107,53,.7)) }
  .filter-violet .tile-overlay { background: linear-gradient(transparent 40%, rgba(100,50,180,.7)) }
  .filter-lime .tile-overlay { background: linear-gradient(transparent 40%, rgba(140,200,0,.6)) }
  .filter-blue .tile-overlay { background: linear-gradient(transparent 40%, rgba(30,80,200,.65)) }
  @media (min-width: 768px) {
    .portfolio-grid { grid-template-columns: repeat(3, 1fr); gap: 16px }
    #home-footer { padding: 20px 40px }
    #home-footer nav { gap: 32px }
    #home-footer nav a { font-size: .75rem }
  }
`

const TILES: { title: string; sub: string; img: string; filter: string; href: string | null }[] = [
  { title: 'Culture Lab',  sub: 'Placemaking Tool',    img: work1,    filter: 'filter-magenta', href: '/culture-lab' },
  { title: 'MagDrops',     sub: 'Magazine Production', img: work2,    filter: 'filter-cyan',    href: '/magdrops' },
  { title: 'Honey House',  sub: 'Creative Family Events', img: honeyHouseImg,   filter: 'filter-orange', href: 'https://honeyhouse.space' },
  { title: 'Yolk Studios', sub: 'Placemaking Studio',  img: yolkIntro,filter: 'filter-violet',  href: '/about' },
  { title: 'About',        sub: 'The Agency',          img: work5,    filter: 'filter-lime',    href: '/about-us' },
  { title: 'LOA',          sub: 'Urban Reset',         img: loaImg,   filter: 'filter-blue',    href: 'https://getloa.co.uk' },
]

export default function Home() {
  const navigate = useNavigate()

  useEffect(() => {
    const prevBg = document.body.style.backgroundColor
    const prevOverflow = document.body.style.overflow
    document.body.style.backgroundColor = '#000'
    document.body.style.overflow = 'hidden'

    const timeouts: ReturnType<typeof setTimeout>[] = []
    let rafId = 0
    let observer: IntersectionObserver | null = null

    const canvas = document.getElementById('particle-canvas') as HTMLCanvasElement
    const ctx = canvas?.getContext('2d')

    function resizeCanvas() {
      if (!canvas || !ctx) return
      canvas.width = innerWidth * devicePixelRatio
      canvas.height = innerHeight * devicePixelRatio
      ctx.scale(devicePixelRatio, devicePixelRatio)
      canvas.style.width = innerWidth + 'px'
      canvas.style.height = innerHeight + 'px'
    }
    resizeCanvas()

    function getPhoneDims() {
      const vw = innerWidth, vh = innerHeight, m = vw < 768
      const pw = m ? vw * 0.5 : Math.min(vw * 0.22, 280)
      const ph = pw * 2
      return { pw, ph, px: (vw - pw) / 2, py: (vh - ph) / 2 - (m ? 20 : 0), bezel: m ? 8 : 10, borderR: m ? 28 : 32 }
    }

    function positionPhone() {
      const { pw, ph, px, py, bezel, borderR } = getPhoneDims()
      const f = document.getElementById('phone-frame')
      const s = document.getElementById('phone-screen')
      if (!f || !s) return
      Object.assign(f.style, {
        width: pw + 'px', height: ph + 'px', left: px + 'px', top: py + 'px',
        border: '3px solid rgba(255,255,255,.15)', borderRadius: borderR + 'px', background: '#000'
      })
      Object.assign(s.style, {
        top: bezel + 'px', left: bezel + 'px',
        width: (pw - bezel * 2) + 'px', height: (ph - bezel * 2) + 'px',
        borderRadius: (borderR - 4) + 'px'
      })
      const ht = document.getElementById('header-text')
      const st = document.getElementById('sub-text')
      const d = document.getElementById('swipe-dots')
      if (ht) ht.style.top = Math.max(py - (innerWidth < 768 ? 75 : 110), 20) + 'px'
      if (st) st.style.top = (py + ph + (innerWidth < 768 ? 14 : 22)) + 'px'
      if (d) {
        d.style.left = '50%'
        d.style.transform = 'translateX(-50%)'
        d.style.top = (py + ph + (innerWidth < 768 ? 44 : 56)) + 'px'
      }
    }

    type Particle = {
      x: number; y: number; sx: number; sy: number; ex: number; ey: number
      size: number; color: number[]; delay: number; sR: number; sS: number; sP: number; z: number; opacity: number
    }
    let particles: Particle[] = []

    function sampleColors(): number[][] {
      const img = document.getElementById('hero-img') as HTMLImageElement
      if (!img) return [[200, 200, 200]]
      const t = document.createElement('canvas')
      t.width = 80; t.height = 60
      const c = t.getContext('2d')
      if (!c) return [[200, 200, 200]]
      try {
        c.drawImage(img, 0, 0, 80, 60)
        const d = c.getImageData(0, 0, 80, 60).data
        const r: number[][] = []
        for (let i = 0; i < d.length; i += 4) r.push([d[i], d[i + 1], d[i + 2]])
        return r
      } catch {
        return [[200, 200, 200]]
      }
    }

    function createParticles() {
      const vw = innerWidth, vh = innerHeight
      const { pw, ph, px, py } = getPhoneDims()
      const colors = sampleColors()
      const n = vw < 768 ? 500 : 1000
      particles = []
      for (let i = 0; i < n; i++) {
        const sx = Math.random() * vw, sy = Math.random() * vh
        const cx = px + pw / 2, cy = py + ph / 2
        const a = Math.random() * Math.PI * 2
        const r = Math.random() * Math.max(pw, ph) * 0.6
        particles.push({
          x: sx, y: sy, sx, sy,
          ex: cx + Math.cos(a) * r, ey: cy + Math.sin(a) * r,
          size: 1.5 + Math.random() * 3,
          color: colors[Math.floor(Math.random() * colors.length)],
          delay: Math.random() * 0.4, sR: 30 + Math.random() * 100,
          sS: (Math.random() - 0.5) * 4, sP: Math.random() * Math.PI * 2,
          z: Math.random(), opacity: 1
        })
      }
    }

    let phase = 'waiting'
    let animStart = 0

    function anim(time: number) {
      if (phase !== 'dissolving' && phase !== 'reforming') {
        if (phase !== 'done') rafId = requestAnimationFrame(anim)
        return
      }
      if (!animStart) animStart = time
      const el = (time - animStart) / 1000
      if (!ctx) return
      ctx.clearRect(0, 0, innerWidth, innerHeight)

      for (const p of particles) {
        const t = Math.max(0, el - p.delay)
        if (t < 2.5) {
          const e = 1 - Math.pow(1 - Math.min(t / 2.5, 1), 3)
          p.x = p.sx + (Math.random() - 0.5) * 200 * e
          p.y = p.sy + (Math.random() - 0.5) * 200 * e
          p.opacity = 0.3 + 0.7 * (1 - e * 0.5)
        } else if (t < 4.5) {
          const e = (t - 2.5) / 2
          const a = p.sP + p.sS * e * Math.PI * 2
          const cx = (p.sx + p.ex) / 2, cy = (p.sy + p.ey) / 2
          const r = p.sR * (1 - e * 0.5)
          p.x = cx + Math.cos(a) * r + (p.ex - cx) * e * 0.5
          p.y = cy + Math.sin(a) * r + (p.ey - cy) * e * 0.5
          p.opacity = 0.5 + 0.5 * e
        } else if (t < 6.5) {
          const e = 1 - Math.pow(1 - Math.min((t - 4.5) / 2, 1), 2)
          p.x += (p.ex - p.x) * e * 0.1
          p.y += (p.ey - p.y) * e * 0.1
          p.opacity = 1 - e * 0.8
        } else {
          p.opacity = Math.max(0, p.opacity - 0.02)
        }
        if (p.opacity > 0.01) {
          const sc = 0.5 + p.z * 0.5
          ctx.globalAlpha = p.opacity * sc
          ctx.fillStyle = `rgb(${p.color[0]},${p.color[1]},${p.color[2]})`
          ctx.beginPath()
          ctx.arc(p.x, p.y, p.size * sc, 0, Math.PI * 2)
          ctx.fill()
        }
      }
      ctx.globalAlpha = 1

      if (el > 5 && phase === 'dissolving') {
        phase = 'reforming'
        const phoneFrame = document.getElementById('phone-frame')
        if (phoneFrame) phoneFrame.style.opacity = '1'
        timeouts.push(setTimeout(() => document.getElementById('phone-img')?.classList.add('visible'), 500))
        timeouts.push(setTimeout(() => document.getElementById('header-text')?.classList.add('visible'), 1000))
        timeouts.push(setTimeout(() => document.getElementById('sub-text')?.classList.add('visible'), 1400))
        timeouts.push(setTimeout(() => {
          document.getElementById('swipe-dots')?.classList.add('visible')
          document.getElementById('phone-frame')?.classList.add('interactive')
          document.getElementById('home-footer')?.classList.add('visible')
          document.getElementById('scroll-cue')?.classList.add('visible')
          document.body.style.overflow = ''
          document.body.style.overflowY = 'auto'
          document.body.style.overflowX = 'hidden'
          document.getElementById('portfolio')?.classList.add('visible')
          observeTiles()
        }, 1800))
      }
      rafId = requestAnimationFrame(anim)
    }

    function createFlash() {
      const el = document.createElement('div')
      el.className = 'home-flash'
      const s = 40 + Math.random() * 80
      Object.assign(el.style, {
        width: s + 'px', height: s + 'px',
        left: (Math.random() * innerWidth - s / 2) + 'px',
        top: (Math.random() * innerHeight - s / 2) + 'px',
        animationDelay: (Math.random() * 0.3) + 's'
      })
      document.body.appendChild(el)
      timeouts.push(setTimeout(() => el.remove(), 1200))
    }

    function startSequence() {
      if (phase !== 'waiting') return
      phase = 'flashing'
      document.getElementById('tap-prompt')?.classList.add('hidden')
      positionPhone()
      buildDots()
      for (let i = 0; i < 8; i++) {
        timeouts.push(setTimeout(createFlash, i * 200 + Math.random() * 150))
      }
      timeouts.push(setTimeout(() => {
        createParticles()
        const hi = document.getElementById('hero-img') as HTMLImageElement
        if (hi) hi.style.opacity = '0'
        timeouts.push(setTimeout(() => { if (hi) hi.style.display = 'none' }, 400))
        phase = 'dissolving'
        animStart = 0
        rafId = requestAnimationFrame(anim)
      }, 1800))
    }

    let cur = 0
    const tot = 4

    function goTo(n: number) {
      cur = Math.max(0, Math.min(n, tot - 1))
      const slides = document.getElementById('slides')
      if (slides) slides.style.transform = `translateX(-${cur * 25}%)`
      document.querySelectorAll('.dot').forEach((d, i) => d.classList.toggle('active', i === cur))
      document.querySelectorAll('.phone-slide-text').forEach((t, i) => {
        if (i + 1 === cur) t.classList.add('visible')
        else t.classList.remove('visible')
      })
    }

    function buildDots() {
      const c = document.getElementById('swipe-dots')
      if (!c) return
      c.innerHTML = ''
      for (let i = 0; i < tot; i++) {
        const d = document.createElement('div')
        d.className = 'dot' + (i === 0 ? ' active' : '')
        d.onclick = () => goTo(i)
        c.appendChild(d)
      }
    }

    let tx = 0
    const phoneScreen = document.getElementById('phone-screen')
    const onTouchStart = (e: Event) => { tx = (e as TouchEvent).touches[0].clientX }
    const onTouchEnd = (e: Event) => {
      const d = tx - (e as TouchEvent).changedTouches[0].clientX
      if (Math.abs(d) > 40) d > 0 ? goTo(cur + 1) : goTo(cur - 1)
    }
    let md = false, mx = 0
    const onMouseDown = (e: Event) => { md = true; mx = (e as MouseEvent).clientX }
    const onMouseUp = (e: Event) => {
      if (md) {
        const d = mx - (e as MouseEvent).clientX
        if (Math.abs(d) > 40) d > 0 ? goTo(cur + 1) : goTo(cur - 1)
        md = false
      }
    }
    phoneScreen?.addEventListener('touchstart', onTouchStart, { passive: true })
    phoneScreen?.addEventListener('touchend', onTouchEnd, { passive: true })
    phoneScreen?.addEventListener('mousedown', onMouseDown)
    document.addEventListener('mouseup', onMouseUp)

    function observeTiles() {
      const tiles = document.querySelectorAll('.portfolio-tile')
      observer = new IntersectionObserver(entries => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            timeouts.push(setTimeout(() => entry.target.classList.add('revealed'), i * 100))
            observer?.unobserve(entry.target)
          }
        })
      }, { threshold: 0.15 })
      tiles.forEach(t => observer?.observe(t))
    }

    const heroImg = document.getElementById('hero-img') as HTMLImageElement
    function showPrompt() {
      timeouts.push(setTimeout(() => document.getElementById('tap-prompt')?.classList.add('visible'), 500))
    }
    if (heroImg) {
      heroImg.onload = showPrompt
      if (heroImg.complete) showPrompt()
    }

    document.addEventListener('click', startSequence)
    document.addEventListener('touchstart', startSequence, { passive: true } as AddEventListenerOptions)

    function onResize() {
      resizeCanvas()
      if (phase === 'reforming' || phase === 'done') positionPhone()
    }
    window.addEventListener('resize', onResize)

    return () => {
      document.body.style.backgroundColor = prevBg
      document.body.style.overflow = prevOverflow
      document.body.style.overflowY = ''
      document.body.style.overflowX = ''
      cancelAnimationFrame(rafId)
      timeouts.forEach(clearTimeout)
      observer?.disconnect()
      document.removeEventListener('click', startSequence)
      document.removeEventListener('touchstart', startSequence)
      document.removeEventListener('mouseup', onMouseUp)
      phoneScreen?.removeEventListener('touchstart', onTouchStart)
      phoneScreen?.removeEventListener('touchend', onTouchEnd)
      phoneScreen?.removeEventListener('mousedown', onMouseDown)
      window.removeEventListener('resize', onResize)
      document.querySelectorAll('.home-flash').forEach(el => el.remove())
    }
  }, [])

  const handleTileClick = (href: string | null) => {
    if (!href) return
    if (href.startsWith('http')) {
      window.open(href, '_blank', 'noopener,noreferrer')
    } else {
      navigate(href)
    }
  }

  const scrollToPortfolio = (e: React.MouseEvent) => {
    e.stopPropagation()
    const portfolio = document.getElementById('portfolio')
    if (portfolio) portfolio.scrollIntoView({ behavior: 'smooth' })
  }

  const handleAbout = (e: React.MouseEvent) => {
    e.stopPropagation()
    navigate('/about-us')
  }

  return (
    <div id="home-root">
      <style dangerouslySetInnerHTML={{ __html: HOME_CSS }} />

      <img id="hero-img" src={heroBg} alt="" crossOrigin="anonymous" />
      <canvas id="particle-canvas" />

      <section id="hero-section">
        <div id="phone-frame">
          <div id="phone-screen">
            <div className="phone-slides" id="slides">
              <div className="phone-slide" style={{ position: 'relative' }}>
                <img id="phone-img" src={heroBg} alt="" />
              </div>
              <div className="phone-slide">
                <div className="phone-slide-text">We curate real life experiences</div>
              </div>
              <div className="phone-slide">
                <div className="phone-slide-text">To tell your story</div>
              </div>
              <div className="phone-slide">
                <div className="phone-slide-text">In a world that&apos;s hungry for content</div>
              </div>
            </div>
          </div>
        </div>
        <div id="swipe-dots" />
        <div className="hero-text" id="header-text">
          <h1>We create the content.</h1>
        </div>
        <div className="hero-text" id="sub-text">
          <p>You capture your story.</p>
        </div>
      </section>

      <div id="tap-prompt">Tap anywhere to begin</div>

      <div id="scroll-cue">
        <span>Scroll</span>
        <div className="arrow" />
      </div>

      <section id="portfolio">
        <div id="portfolio-header">
          <h2>Selected Work</h2>
          <p>Content &middot; Culture &middot; Community</p>
        </div>
        <div className="portfolio-grid">
          {TILES.map((tile) => (
            <div
              key={tile.title}
              className={`portfolio-tile ${tile.filter}`}
              onClick={(e) => { e.stopPropagation(); handleTileClick(tile.href) }}
              style={{ cursor: tile.href ? 'pointer' : 'default' }}
            >
              <img className="tile-img" src={tile.img} alt={tile.title} />
              <div className="tile-overlay">
                <h3>{tile.title}</h3>
                <span>{tile.sub}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div id="home-footer">
        <div className="logo">TCGL</div>
        <nav>
          <a onClick={handleAbout}>About</a>
          <a onClick={scrollToPortfolio}>Work</a>
          <a href="mailto:hello@thecontentgroup.co" onClick={(e) => e.stopPropagation()}>Contact</a>
        </nav>
      </div>
    </div>
  )
}
